import { ModuleConfig } from '@/core/module';
import { accessLevelRoutes } from './routes';
import { useAccessLevelStore } from './stores/access-level-store';

export const AccessLevelModule: ModuleConfig = {
    name: 'access-level',
    routes: accessLevelRoutes,
    stores: {
        accessLevel: useAccessLevelStore
    },
    initialize: () => {
        console.log('Access Level module initialized');
    }
};